module.exports = __webpack_public_path__ + "img/32.75f04c72.png";